import { AccordionSection } from "../../../components/accordion";
import React, { useState } from "react";
import { usePhotos } from "../../hooks/api/use-photos";
import { ImagePopout } from "../../../components/image-stream/image-popout";
import "./reference-images.scss";

export const ReferenceImages = ({ photographyWipKey, shipmentKey, shipmentProductKey }) => {
    const [isOpen, setOpen] = useState(true);
    const { data: shots } = usePhotos(photographyWipKey);
    const editedShots = shots?.filter(({ editedImageUris }) => Boolean(editedImageUris));
    const uneditedShots = shots?.filter(({ uneditedImageUris }) => Boolean(uneditedImageUris));

    return (
        <div className="accordion">
            <AccordionSection
                label="Reference Images"
                isOpen={isOpen}
                arrowOnly={false}
                onClick={() => setOpen(!isOpen)}
            >
                <div className="reference-images-rows">
                    <div>
                        <h4>Unedited</h4>
                        <div className="reference-images-grid">
                            {uneditedShots?.map(({ id, uneditedImageUris, imageViewDescription, imageView }) => (
                                <div
                                    key={id}
                                    className="image-wrapper"
                                >
                                    <div className="thumbnail-container -md">
                                        <ImagePopout
                                            photoKey={`img_unedited_${photographyWipKey}_${id}`}
                                            imageUris={uneditedImageUris || { small: "", medium: "", normal: "" }}
                                            alt={`Unedited ${imageViewDescription || imageView}`}
                                            shipmentKey={shipmentKey}
                                            shipmentProductKey={shipmentProductKey}
                                            imageSize="medium"
                                        />
                                    </div>
                                    <div className="m-t-6 image-view-description txt-wrap">{imageViewDescription || imageView}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {editedShots?.length > 0 && (
                        <div>
                            <h4>Edited</h4>
                            <div className="reference-images-grid">
                                {editedShots.map(({ id, editedImageUris, imageViewDescription, imageView }) => (
                                    <div
                                        key={id}
                                        className="image-wrapper"
                                    >
                                        <div className="thumbnail-container -md">
                                            <ImagePopout
                                                photoKey={`img_edited_${photographyWipKey}_${id}`}
                                                imageUris={editedImageUris || { small: "", medium: "", normal: "" }}
                                                alt={`Edited ${imageViewDescription || imageView}`}
                                                shipmentKey={shipmentKey}
                                                shipmentProductKey={shipmentProductKey}
                                                imageSize="medium"
                                            />
                                        </div>
                                        <div className="m-t-6 image-view-description txt-wrap">{imageViewDescription || imageView}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </AccordionSection>
        </div>
    );
};
